import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import {
  Button,
  Typography,
  IconButton,
  Dialog,
  DialogHeader,
  DialogBody,
  DialogFooter,
  Card,
  CardBody,
} from "@material-tailwind/react";
import { ClipboardDocumentIcon } from "@heroicons/react/24/outline";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { useState } from "react";

import Loading from "../../Component/Loading";
import service from "../../service";

const APIKey = () => {
  const [isOpen, setIsOpen] = useState(false);
  const handleClick = () => {
    setIsOpen(!isOpen);
  };
  const queryClient = useQueryClient();
  const createKey = useMutation({
    mutationFn: service.createKey,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["profile"] });
    },
  });
  const profile = useQuery({
    queryKey: ["profile"],
    queryFn: service.getProfile,
  });

  const hasKey = !!profile?.data?.auto?.key;
  const key = profile?.data?.auto?.key;
  const isLoading = createKey.isLoading || profile.isLoading;

  return (
    <>
      <Card className="rounded-2xl border border-blue-gray-100 shadow-sm">
        <CardBody className="p-4 sm:p-6">
          {hasKey && (
            <div className="mb-5 flex min-w-0 items-center gap-x-2">
              <Typography
                variant="h6"
                className="min-w-0 flex-1 break-all rounded-lg bg-blue-gray-100 p-3 font-mono text-sm text-blue-gray-800 sm:text-base"
              >
                {key}
              </Typography>
              <CopyToClipboard
                text={key}
                onCopy={() => {
                  alert("Already copied");
                }}
              >
                <IconButton variant="outlined">
                  <ClipboardDocumentIcon className="h-5 w-5" />
                </IconButton>
              </CopyToClipboard>
            </div>
          )}

          <Button
            onClick={handleClick}
            color="green"
            className="flex h-10 w-full items-center justify-center gap-x-1 px-4 py-2 sm:w-auto"
            disabled={isLoading}
          >
            {isLoading && <Loading size={28} />}
            {hasKey ? "สร้างใหม่" : "สร้าง"}
          </Button>
        </CardBody>
      </Card>
      <Dialog open={isOpen} size="xs" handler={handleClick}>
        <DialogHeader>
          คุณต้องการที่จะสร้าง API Key ใหม่ใช่หรือไม่?
        </DialogHeader>
        <DialogBody divider>
           *** ถ้า API Key ใหม่ถูกสร้าง API Key อันเก่าจะใช้ไม่ได้
        </DialogBody>
        <DialogFooter className="flex flex-col justify-center gap-2 sm:flex-row">
          <Button
            color="green"
            onClick={() => {
              createKey.mutate();
              handleClick();
            }}
            className="m-0 w-full sm:w-auto"
          >
            สร้าง API Key ใหม่
          </Button>
          <Button color="red" onClick={handleClick} className="w-full sm:w-auto">
            ออกจากหน้านี้
          </Button>
        </DialogFooter>
      </Dialog>
    </>
  );
};

export default APIKey;
